import React from "react";
import ReactDOMServer from "react-dom/server";
import tippy, {roundArrow, followCursor, hideAll} from "tippy.js";
import {Translate, translate} from "react-i18nify";

import "tippy.js/themes/light.css";
import "tippy.js/animations/scale.css";
import "tippy.js/dist/svg-arrow.css";

import * as keyCodes from "../constants/keyCodes";
import * as settings from "../constants/settings";
import * as translationHelper from "../helpers/translationHelper";

import imgLoader from "../resources/img/loader.svg";

export const createTooltip = (event) => {
    if (
        event.currentTarget.dataset.text !== undefined &&
        event.currentTarget.dataset.text !== null &&
        event.currentTarget.dataset.text !== ""
    ) {
        if (window.storeProvider.getZoom() === 100) {
            tippy(event.currentTarget, {
                arrow: roundArrow,
                duration: [200, 400],
                animation: "scale",
                theme: "redlike",
                zIndex: 900000,
                content: event.currentTarget.dataset.text,
                onHidden(instance) {
                    instance.destroy();
                },
                popperOptions: {
                    modifiers: {
                        preventOverflow: {enabled: false},
                        hide: {enabled: false}
                    }
                }
            });
        } else {
            tippy(event.currentTarget, {
                arrow: roundArrow,
                duration: [200, 400],
                animation: "scale",
                theme: "redlike",
                zIndex: 900000,
                content: event.currentTarget.dataset.text,
                followCursor: true,
                offset: [0, 10],
                plugins: [followCursor],
                onHidden(instance) {
                    instance.destroy();
                },
                popperOptions: {
                    modifiers: {
                        preventOverflow: {enabled: false},
                        hide: {enabled: false}
                    }
                }
            });
        }
    }
};

export const createSummaryTooltip = (event) => {
    if (
        event.target.dataset.product !== undefined &&
        event.target.dataset.product !== null &&
        event.target.dataset.product !== [] &&
        event.target.dataset.color !== undefined &&
        event.target.dataset.color !== null &&
        event.target.dataset.color !== [] &&
        event.target.dataset.base !== undefined &&
        event.target.dataset.base !== null &&
        event.target.dataset.base !== [] &&
        event.target.dataset.package !== undefined &&
        event.target.dataset.package !== null &&
        event.target.dataset.package !== []
    ) {
        if (window.storeProvider.getZoom() === 100) {
            tippy(event.target, {
                arrow: roundArrow,
                duration: [200, 400],
                animation: "scale",
                theme: "custom-tooltip",
                zIndex: 900000,
                allowHTML: true,
                content: getSummaryTooltipContent(event),
                onHidden(instance) {
                    instance.destroy();
                },
                popperOptions: {
                    modifiers: {
                        preventOverflow: {enabled: false},
                        hide: {enabled: false}
                    }
                }
            });
        } else {
            tippy(event.target, {
                arrow: roundArrow,
                duration: [200, 400],
                animation: "scale",
                theme: "custom-tooltip",
                zIndex: 900000,
                allowHTML: true,
                content: getSummaryTooltipContent(event),
                followCursor: true,
                plugins: [followCursor],
                onHidden(instance) {
                    instance.destroy();
                },
                popperOptions: {
                    modifiers: {
                        preventOverflow: {enabled: false},
                        hide: {enabled: false}
                    }
                }
            });
        }
    }
};

export const createSearchPanelTooltip = (event) => {
    if (event.currentTarget.value.length > 0) {
        if (event.currentTarget.dataset.size === "1") {
            tippy(event.currentTarget, {
                arrow: roundArrow,
                delay: [2000, 200],
                duration: [200, 400],
                animation: "scale",
                theme: "redlike",
                zIndex: 900000,
                content: event.currentTarget.value,
                onHidden(instance) {
                    instance.destroy();
                },
                popperOptions: {
                    modifiers: {
                        preventOverflow: {enabled: false},
                        hide: {enabled: false}
                    }
                }
            });
        } else {
            tippy(event.currentTarget, {
                arrow: roundArrow,
                delay: [2000, 200],
                duration: [200, 400],
                animation: "scale",
                theme: "redlike",
                zIndex: 900000,
                content: event.currentTarget.value,
                followCursor: true,
                offset: [0, 20],
                plugins: [followCursor],
                onHidden(instance) {
                    instance.destroy();
                },
                popperOptions: {
                    modifiers: {
                        preventOverflow: {enabled: false},
                        hide: {enabled: false}
                    }
                }
            });
        }
    }
};

export const createTicketTooltip = (event, resources) => {
    tippy(event.target, {
        arrow: roundArrow,
        duration: [200, 400],
        animation: "scale",
        theme: "light",
        zIndex: 900000,
        allowHTML: true,
        content: getTicketTooltipContent(resources),
        followCursor: true,
        plugins: [followCursor],
        onHidden(instance) {
            instance.destroy();
        },
        popperOptions: {
            modifiers: {
                preventOverflow: {enabled: false},
                hide: {enabled: false}
            }
        }
    });
};

export const destroyAll = () => {
    hideAll();
};

export const getTooltipTextForKeyboardShortcut = (keyboardShortcutObject) => {
    if (keyboardShortcutObject === null || !keyboardShortcutObject.active) {
        return "";
    }

    let tooltipText = [];

    if (keyboardShortcutObject.ctrl) {
        tooltipText.push(settings.KEY_NAME_CTRL);
    }

    if (keyboardShortcutObject.shift) {
        tooltipText.push(settings.KEY_NAME_SHIFT);
    }

    if (keyCodes.SHORTCUT_KEYS.includes(keyboardShortcutObject.keyCode)) {
        tooltipText.push(translationHelper.getKeyCodesTranslation(keyboardShortcutObject.keyCode));
    }

    return tooltipText.join(" + ");
};

const getSummaryTooltipContent = (event) => {
    return ReactDOMServer.renderToStaticMarkup(
        <div className="tooltip-summary custom-tooltip">
            <div className="row">
                <div className="col-xs-12 tooltip-title color-primary">
                    <Translate value="sendOrderModal.orderOverview" />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-6 color-primary">
                    <Translate value="general.product" />
                </div>
                <div className="col-xs-6">{event.target.dataset.product}</div>
                <div className="col-xs-6 color-primary">
                    <Translate value="general.color" />
                </div>
                <div className="col-xs-6">{event.target.dataset.color}</div>
                <div className="col-xs-6 color-primary">
                    <Translate value="general.base" />
                </div>
                <div className="col-xs-6">{event.target.dataset.base}</div>
                <div className="col-xs-6 color-primary">
                    <Translate value="general.canSize" />
                </div>
                <div className="col-xs-6">{event.target.dataset.package}</div>
            </div>
        </div>
    );
};

const getTicketTooltipContent = (resources) => {
    return ReactDOMServer.renderToStaticMarkup(
        <div>
            <div className="flex flex-wrap flex-align-center-vertical line-height-2_7vh">
                <b className="margin-right-5">{translate("general.type")}:</b>
                <div className="flex flex-align-center-vertical">
                    <span>{resources.type.text}</span>
                </div>
            </div>
            <div className="padding-bottom-5 flex flex-wrap">
                <b className="margin-right-5">{translate("general.status")}:</b>
                <div className="flex flex-align-center-vertical">
                    <span
                        className="dot margin-right-5"
                        style={{
                            backgroundColor: resources.status.color
                        }}
                    ></span>
                    {resources.status.text}
                </div>
            </div>
            <div className="flex flex-wrap padding-bottom-5">
                <b className="margin-right-5">{translate("ticketing.comment")}:</b>
                <span
                    style={{
                        textAlign: "start",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}
                >
                    {resources.message.request}
                </span>
            </div>
            {resources.message.answer ? (
                <div className="flex flex-wrap ">
                    <b className="margin-right-5">{translate("ticketing.answer")}:</b>
                    <span
                        style={{
                            textAlign: "start",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                    >
                        {resources.message.answer}
                    </span>
                </div>
            ) : null}
        </div>
    );
};

export const getImageTooltipContent = (image) => {
    if (image === null) {
        return ReactDOMServer.renderToStaticMarkup(
            <div className="row">
                <div className="col-xs-12">
                    <img alt="loading" src={imgLoader} />
                </div>
            </div>
        );
    }

    return ReactDOMServer.renderToStaticMarkup(
        <div className="row">
            <div className="col-xs-12">
                <img
                    alt=""
                    src={"data:" + image.type + ";base64," + image.img}
                    style={{maxHeight: "200px", maxWidth: "200px"}}
                />
            </div>
        </div>
    );
};

export const createImageTooltip = (event, image) => {
    return tippy(event.target, {
        arrow: roundArrow,
        duration: [200, 400],
        animation: "scale",
        theme: "custom-tooltip",
        zIndex: 900000,
        allowHTML: true,
        content: getImageTooltipContent(image),
        onHidden(instance) {
            instance.destroy();
        },
        popperOptions: {
            modifiers: {
                preventOverflow: {enabled: false},
                hide: {enabled: false}
            }
        }
    });
};
